export default "__VITE_ASSET__B$pgsMlg__"